"use client";

import * as React from "react";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { Check } from "lucide-react";

import { cn } from "../../lib/utils";
import {
  FormControl,
  FormItem,
  FormMessage,
  FormLabel,
  FormDescription,
} from "../form";

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      "peer h-4 w-4 shrink-0 rounded-sm border border-primary ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground",
      className
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator
      className={cn("flex items-center justify-center text-current")}
    >
      <Check className="h-4 w-4" />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };

export const FormCheckbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root> & {
    label: string;
    description?: string;
  }
>(({ className, label, description, ...props }, ref) => (
  <FormItem className={cn("flex flex-row items-center gap-2", className)}>
    <FormControl>
      <Checkbox className="mb-0" {...props} ref={ref} />
    </FormControl>
    <div className="flex flex-col gap-1">
      <FormLabel className={cn("text-sm", props.disabled && "opacity-50")}>
        {label}
      </FormLabel>
      {description && (
        <FormDescription className="text-xs">{description}</FormDescription>
      )}
      <FormMessage />
    </div>
  </FormItem>
));
FormCheckbox.displayName = CheckboxPrimitive.Root.displayName;
